import { OnsiteSearchCriteria } from '../OnsiteSearchCriteria.js';

function OnsiteSearchCriteriaFactory($rootScope) {
    var searchCriteria = _.create({}, OnsiteSearchCriteria);

    return {
        get: function () {
            return _.assign({}, searchCriteria);
        },

        set: function (inCriteria) {
            searchCriteria = _.assign(searchCriteria, inCriteria);
            $rootScope.$broadcast('onsite-search-criteria-changed', searchCriteria);
        },

        clear: function () {
            searchCriteria = _.create({}, OnsiteSearchCriteria);
        }
    };
}

angular.module('onsite').factory('onsiteSearchCriteriaFactory', ['$rootScope', OnsiteSearchCriteriaFactory]);
